<template>
  <div class="inr-payments-enabled-container">
    <div class="heading-container mb-3">
      <div class="heading">
        {{ $t('account.index.currencySettings.paymentEnabledBanner.title') }}
        <div class="chip">
          {{ $t('account.index.currencySettings.paymentEnabledBanner.chip') }}
        </div>
      </div>
      <div class="disable-inr" @click="openDisableINRDrawer">
        {{ $t('account.index.currencySettings.paymentEnabledBanner.button') }}
      </div>
    </div>
    <div class="content">
      {{ $t('account.index.currencySettings.paymentEnabledBanner.content') }}
    </div>
    <disable-drip-switch-sidebar
      :isDisableDripSwitchOpen="isDisableDripSwitchDrawerOpen"
      :dataToSend="getDisableDripSwitchApiData"
      :onCancel="onDrawerCancel"
      :onClose="onDrawerClose"
      :onSuccess="onSuccess"
    />
    <dialog-box
      v-if="isTaskCompletedModal"
      dialogWidth="600px"
      @close="isTaskCompletedModal = false"
    >
      {{ stopLottie() }}
      <div class="dialog-content">
        <lottie-player
          :src="fetchLottieJSON"
          background="transparent"
          speed="1"
          style="width: 100%; height: 170px"
          :loop="lottieLoop"
          class="dialog-img"
          autoplay
        ></lottie-player>
        <div class="dialog-header">
          {{
            $t(
              'account.index.currencySettings.paymentEnabledBanner.dialog.heading'
            )
          }}
        </div>
        <div class="dialog-body">
          {{
            $t(
              'account.index.currencySettings.paymentEnabledBanner.dialog.body'
            )
          }}
        </div>
      </div>
    </dialog-box>
  </div>
</template>
<script>
import DisableDripSwitchSidebar from '@/components/drip-switch/DisableDripSwitchSidebar.vue'
import DialogBox from '@/components/common/DialogBox'
import PaperPlane from '@/assets/images/lottie/paperplane.json'

export default {
  props: ['onStatusToggleSuccess'],
  data() {
    return {
      isDisableDripSwitchDrawerOpen: false,
      isTaskCompletedModal: false,
      lottieLoop: true,
      lottieJSON: PaperPlane
    }
  },
  methods: {
    stopLottie() {
      if (this.isTaskCompletedModal) {
        setTimeout(() => {
          this.lottieLoop = false
        }, 4000)
      }
    },
    openDisableINRDrawer() {
      this.$mpTrack(
        'Clicks "Disable INR Payment" on the currency settings page'
      )
      this.isDisableDripSwitchDrawerOpen = true
    },
    onDrawerClose() {
      this.isDisableDripSwitchDrawerOpen = false
      this.onStatusToggleSuccess()
    },
    onDrawerCancel() {
      this.isDisableDripSwitchDrawerOpen = false
    },
    onSuccess() {
      this.isTaskCompletedModal = true
    }
  },
  computed: {
    fetchLottieJSON() {
      return JSON.stringify(this.lottieJSON)
    },
    getDisableDripSwitchApiData() {
      return {
        user_id: this.$store.state.account.accountId,
        enabled: false
      }
    }
  },
  components: {
    DisableDripSwitchSidebar,
    DialogBox
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_palette.scss';
.inr-payments-enabled-container {
  display: flex;
  flex-direction: column;
  border-width: 8px 1px 1px 1px;
  border-style: solid;
  border-color: $sky-blue-400;
  border-radius: 8px;
  padding: 24px;
  .heading-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media screen and (max-width: $tablet) {
      flex-direction: column;
      align-items: start;
    }
    justify-content: space-between;
    .disable-inr {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: $wealthy-green-500;
      border-radius: 8px;
      padding: 8px;
      cursor: pointer;
      &:hover {
        background: $wealthy-green-50;
        color: $wealthy-green-500;
        text-decoration: underline;
      }
    }
    .heading {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media screen and (max-width: $tablet) {
        flex-direction: column;
        align-items: start;
      }
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      color: $noble-blue-500;
      margin-bottom: 0px;
      .chip {
        display: flex;
        background: $sky-blue-50;
        border: 1px solid $sky-blue-400;
        border-radius: 24px;
        font-weight: 400;
        font-size: 10px;
        line-height: 0;
        color: $noble-blue-500;
        align-items: center;
        padding: 6px;
        height: 20px;
        margin-left: 16px;
        @media screen and (max-width: $tablet) {
          margin-left: 2px;
        }
      }
    }
  }
}
.dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .dialog-img {
    object-fit: cover;
    height: 200px;
    width: 480px;
    margin: auto;
  }
  .dialog-header {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: $noble-blue-500;
    margin-bottom: 8px;
  }
  .dialog-body {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: $black;
  }
}
</style>
